// i18next
import i18n from "i18next";

// react-i18next
import { initReactI18next } from "react-i18next";

// i18next-http-backend
import HttpApi from "i18next-http-backend";

// i18next-browser-languagedetector
import LanguageDetector from "i18next-browser-languagedetector";

// A ---------------------------------------------------------------------- M

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    detection: {
      order: ["cookie", "localStorage", "sessionStorage", "navigator", "htmlTag", "path", "subdomain"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
